import request from '@/router/axios'
import env from '@/config/env'

// 保存摆渡调度配置
export const saveFerrySchedule = (data) => {
  return request({
    url: env.ferryUrl + '/systemConfig/ferrySchedule/save',
    method: 'POST',
    data
  })
}

// 获取摆渡调度配置
export const getFerrySchedule = (data) => {
  return request({
    url: env.ferryUrl + '/systemConfig/ferrySchedule',
    method: 'get'
  })
}

// 获取司机申请列表
export const queryDirverNearbyPage = (data) => {
  return request({
    url: env.ferryUrl + '/dirverNearby/page',
    method: 'POST',
    data
  })
}

// 司机申请开通顺路审核--通过
export const checkDirverNearbyAuth = (params) => {
  return request({
    url: env.ferryUrl + '/dirverNearby/auth',
    method: 'get',
    params
  })
}

// 司机申请开通顺路审核--关闭
export const checkDirverNearbyClose = (params) => {
  return request({
    url: env.ferryUrl + '/dirverNearby/close',
    method: 'get',
    params
  })
}

// 司机申请开通顺路审核--不通过
export const checkDirverNearbyNoAuth = (params) => {
  return request({
    url: env.ferryUrl + '/dirverNearby/noAuth',
    method: 'get',
    params
  })
}

// 司机申请开通顺路审核--日志
export const checkDirverNearbyLogPage = (data) => {
  return request({
    url: env.ferryUrl + '/dirverNearby/logPage',
    method: 'post',
    data
  })
}
